import { filecertGet } from "@/plugins/request";

export default {
  getCollaborationLaunchList: () =>
    filecertGet("/yscro/survey/survey/getCollaborationLaunchList"),
};
